export const QUERY_NAME_DASHBOARD = 'report_id';
export const QUERY_NAME_HOME = 'home';
export const QUERY_FROM_MENU = 'from_menu';

export default {
    QUERY_NAME_DASHBOARD,
    QUERY_NAME_HOME,
    QUERY_FROM_MENU
};
